import { render, staticRenderFns } from "./WorkshopClientHeaderCpt.vue?vue&type=template&id=220f19da&"
import script from "./WorkshopClientHeaderCpt.vue?vue&type=script&lang=ts&"
export * from "./WorkshopClientHeaderCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports